<div class="image-wrapper">
  <img
    alt=""
    ngSrc="./assets/img/flags/{{ language.substring(0, 2) | langToCountryCode }}.svg"
    width="32"
    height="32"
  />
</div>
<span>{{ ("languages." + language) | translate }}</span>
